/**
 * Live (fleet) Alarms explore page.
 * Columns: Datetime | Category | Source | Description.
 *
 * Reads the same alarms parquet family as the day page — the stream server flushes it every 10 s,
 * so this is near-live rather than pushed; there is no websocket alarm topic. `live` makes the page
 * re-read on that same cadence and list the newest alarms first.
 */
import AlarmsReportSection from "../../../../components/reports/AlarmsReportSection";

export default function LiveAlarmsPage(props: Record<string, unknown>) {
  return <AlarmsReportSection {...props} variant="fleet" live />;
}
